import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { NvIconModule } from '../nv-icon/nv-icon.module';
import { NvIconButtonComponent } from './nv-icon-button.component';
import { NvAriaLabelModule } from '../directives/nv-aria-label/nv-aria-label.module';

@NgModule({
  imports: [CommonModule, NvIconModule, MatRippleModule, NvAriaLabelModule],
  declarations: [NvIconButtonComponent],
  exports: [NvIconButtonComponent],
})
export class NvIconButtonModule {}
